import React from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

import Wrapper from '../../elements/wrapper';
import { media, TransitionMixin } from '../../helpers';

const BrandedCTAContainer = styled.div`
    padding: 100px 0 140px;

    .title-container {
        text-align: center;
        margin-bottom: 50px;
        h3 {
            font-weight: 800;
            font-family: neue-kabel, sans-serif;
            font-size: 3rem;
            color: #000;
        }

        p {
            font-size: 1rem;
            color: #000;
            margin: 0 auto;
            max-width: 420px;
        }
    }

    .icons-wrapper {
        max-width: 500px;
        display: flex;
        margin-bottom: 50px;

        .item-container {
            flex: 1;
            .inner-wrap {
                max-width: 90%;
                margin: 0 auto;
                text-align: center;

                .image-container {
                    max-width: 50px;
                    margin: 0 auto 10px;
                }

                .content-container {
                    h4 {
                        color: #000;
                        font-size: 0.9rem;
                        margin: 0 0 10px;
                    }

                    p {
                        font-size: 0.8rem;
                        color: #000;
                        line-height: 1.5;
                        margin-bottom: 0px;
                    }
                }
            }
        }
    }

    .btn-container {
        text-align: center;
        a {
            color: #fff;
            border: none;
            background-color: #f74d33;
            font-weight: 700;
            line-height: 1;
            width: 100%;
            max-width: 250px;
            border-radius: 5px;
            border: 1px solid #f74d33;
            text-decoration: none;
            padding: 20px 0;
            display: inline-block;
            ${TransitionMixin('.25s')}

            &:hover {
                color: #f74d33;
                background-color: #fff;
            }
        }
    }
`;

const BrandedCTA = ({ content }) => {
    const { ctaButton, ctaIcons, ctaTitle, ctaCaption } = content || {};
    return (
        <BrandedCTAContainer>
            <Wrapper className="title-container">
                <h3>{ctaTitle}</h3>
                <p>{ctaCaption}</p>
            </Wrapper>
            <Wrapper className="icons-wrapper">
                {ctaIcons &&
                    ctaIcons.map((icon) => {
                        const { iconImage, iconTitle, iconBlurb } = icon || {};
                        return (
                            <div className="item-container">
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        <Img
                                            fluid={
                                                iconImage.localFile
                                                    .childImageSharp.fluid
                                            }
                                        />
                                    </div>
                                    <div className="content-container">
                                        <h4>{iconTitle}</h4>
                                        <p>{iconBlurb}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="btn-container">
                {ctaButton && <Link to={ctaButton.url}>{ctaButton.title}</Link>}
            </Wrapper>
        </BrandedCTAContainer>
    );
};

export default BrandedCTA;
